import { useState } from "react";

// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Custom Components
import Tooltip from "components/layout/Tooltip";
import SelectorSelectMulti from "components/layout/DropdownSelectors/SelectorSelectMulti";
import { UserpanelRow } from "containers/Userpanel/components/UserpanelRow";

// ** Utils & Helpers
import useSelectorLanguage from "hooks/selectors/useSelectorLanguage";

// #####################################################

const Language = ({
	data,
	onAccept,
	isBan,
	isKeyboardOpen,
	visualViewportHeight,
	autoFocus,
	tooltipInfo,
}) => {
	const { t } = useTranslation(["filtersAndSelectors", "userpanel"]);

	const [choosen, setChoosen] = useState(data);

	const { items, selected, setSelected } = useSelectorLanguage({
		multiple: true,
		initial: choosen,
	});

	const tooltipWrapperStyle = {
		display: "flex",
		flexDirection: "row",
		width: "100%",
	};

	// #####################################################

	return (
		<Tooltip text={tooltipInfo} wrapperStyle={tooltipWrapperStyle}>
			<UserpanelRow>
				<SelectorSelectMulti
					label={t("filtersAndSelectors:languageLabel")}
					emptyText={t("common:choose")}
					items={items}
					selected={selected}
					onAccept={(value) => {
						setSelected(value);
						setChoosen(value);
						onAccept(value);
					}}
					withSearchInput
					withMobileVersion
					selectedLimit={5}
					selectedLimitText={t(
						"userpanel:data.cantSaveMoreLanguages"
					)}
					activatorStyleOptions={{
						noPad: true,
						noTopMargin: true,
						flex1: true,
					}}
					isBan={isBan}
					allwaysSelected
					isKeyboardOpen={isKeyboardOpen}
					visualViewportHeight={visualViewportHeight}
					customMobileLayerStyle={{
						display: "flex",
						flexDirection: "column",
					}}
					isSingleDropdown={true}
					autoFocus={autoFocus}
				/>
			</UserpanelRow>
		</Tooltip>
	);
};

// #####################################################

export default Language;

// #####################################################
